<template>
  <CardViewer class="iframe-viewer" :text="text" :icon="icon" :isFullscreen="true" cardClassName="iframe-card">
    <iframe class="iframe-view-content" :src="src" frameborder="0"></iframe>
    <template #fullscreen>
      <iframe :src="src" frameborder="0"></iframe>
    </template>
  </CardViewer>
</template>

<script>
import { svgIcons } from '../configs/icon'
import CardViewer from './CardViewer'

export default {
  name: 'app-viewer',
  components: {
    CardViewer,
  },
  props: {
    src: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      icon: svgIcons.iframe,
    }
  },
}
</script>

<style lang="scss" scoped>
.iframe-view-content {
  width: 100%;
  height: 618px;
  position: relative;
  z-index: 1;
  border-radius: 10px;
}
</style>